export default __webpack_public_path__ + "static/media/operatory_1.24a48582.png";